import { render, staticRenderFns } from "./WapMyHome.vue?vue&type=template&id=9be5a974&scoped=true&"
import script from "./WapMyHome.vue?vue&type=script&lang=js&"
export * from "./WapMyHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be5a974",
  null
  
)

export default component.exports